import defaultKpis from '../../../data/defaultKpis.json';
import _ from 'lodash';

export const assignDefaultKpis = async (googleResponses, setGoogleResponses, report, setReport) => {
   
    let campaigns = report.campaigns;

    for await ( let campaign of campaigns ) {
        
        const matchingGoogleCampaign = googleResponses.campaignData.find(obj => obj.campaign.id === campaign.campaign.id);
        
        if ( !campaign.kpis || campaign.kpis.length === 0 ) {
            let kpis = [];
            if ( matchingGoogleCampaign?.kpis?.length > 0 ) for ( const kpi of matchingGoogleCampaign?.kpis ) {
                if ( defaultKpis.includes(kpi?.originalKey) ) kpis.push(kpi);
            }
            campaign.kpis = kpis;
        } 
    }
    setReport({...report, campaigns: campaigns})

    // let campaignData = googleResponses.campaignData;

    // campaignData = _.uniqBy(campaignData, 'campaign.id')
    // campaignData = campaignData.filter(googleObj => report?.campaigns?.some(repObj => repObj.campaign.id === googleObj.campaign.id))

    // if ( campaignData?.length !== googleResponses.campaignData?.length ) setGoogleResponses({...googleResponses, campaignData: campaignData})
}